module.exports = __webpack_public_path__ + "SensorFlow-White.6b4d95f010e0fd4a6191.png";


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/img/SensorFlow-White.png
// module id = ../../../../../src/img/SensorFlow-White.png
// module chunks = styles